<div class="root-container">
  @if (enable_nav) {
    <i class="bi bi-arrow-left back-button"
    (click)="back()"></i>
  }
  @if (bi_icon) {
    <i [class]="['bi',bi_icon]"></i>
  }
  <div class="title">{{ text }}</div>
  <div class="d-flex justify-content-end w-100 align-items-center gap-2">
    <ng-content></ng-content>
  </div>
</div>
